'use strict';

import angular from 'angular';

import activeIncidentsDirective from './directive';

const MODULE_NAME = 'daupler.incidents.components.activeIncidents';

var app = angular.module(MODULE_NAME, [
]);
app.directive('activeIncidents', activeIncidentsDirective);

export default MODULE_NAME;
